export default "__VITE_ASSET__DW7F1TCR__"